import { defineComponent, ref, computed, toRef, resolveComponent, openBlock, createBlock, withCtx, createElementVNode, mergeProps, normalizeClass, renderSlot, createCommentVNode } from 'vue';
import { onClickOutside, useSwipe, SwipeDirection } from '@vueuse/core';
import { t as te } from '../OrAutocompleteV3-8c6de221.js';
import { OrOverlayV3 as script$1 } from '../or-overlay-v3/index.js';
import '@onereach/styles/screens.json';
import '@onereach/styles/tailwind.config.json';
import 'lodash/get';
import 'lodash/isElement';
import '../or-error-v3/index.js';
import '../or-hint-v3/index.js';
import '../or-icon-button-v3/index.js';
import '../or-icon-v3/index.js';
import '../or-tooltip-v3/index.js';
import '../or-popover-v3/index.js';
import '@floating-ui/dom';
import '../or-bottom-sheet-v3/index.js';
import '../or-teleport-v3/index.js';
import '../or-input-box-v3/index.js';
import '../or-input-v3/index.js';
import '../OrInlineInputV3-061441a3.js';
import '../or-inline-input-box-v3/index.js';
import '../or-text-v3/index.js';
import '../or-label-v3/index.js';
import '../or-loader-v3/index.js';
import '../or-menu-item-v3/index.js';
import '../or-tag-input-v3/index.js';
import '../or-tags-v3/index.js';
import '../or-button-v3/index.js';
import '../or-tag-v3/index.js';

var DrawerPlacement;
(function (DrawerPlacement) {
  DrawerPlacement["Left"] = "left";
  DrawerPlacement["Right"] = "right";
})(DrawerPlacement || (DrawerPlacement = {}));

const Drawer = [
// Position
'absolute inset-y-0',
// Box
'max-w-[min(360px,100%-theme(spacing.md))]',
// Spacing
'px-0', 'py-sm+',
// Elevation
'shadow-modal', 'dark:shadow-modal-dark',
// Theme
'theme-foreground-default', 'dark:theme-foreground-default-dark', 'theme-background-default', 'dark:theme-background-default-dark',
// Transition
'transition-transform duration-medium ease-standard'];
const DrawerPlacements = {
  [DrawerPlacement.Left]: [
  // Position
  'start-0',
  // Shape
  'rounded-e-xl'],
  [DrawerPlacement.Right]: [
  // Position
  'end-0',
  // Shape
  'rounded-s-xl']
};
const DrawerPadding = [
// Spacing
'px-md', 'py-md'];
const DrawerContent = [
// Overflow
'overflow-auto',
// Box
'w-full', 'h-full'];

var script = defineComponent({
  name: 'OrDrawer',
  components: {
    OrOverlay: script$1
  },
  inheritAttrs: false,
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    placement: {
      type: String,
      default: () => DrawerPlacement.Left
    },
    padding: {
      type: Boolean,
      default: true
    }
  },
  emits: ['update:state', 'open', 'close'],
  expose: ['root', 'state', 'open', 'close', 'toggle'],
  setup(props, context) {
    // Refs & Styles
    const root = ref();
    const rootStyles = computed(() => ['or-drawer-v3', ...Drawer, ...DrawerPlacements[props.placement], ...(props.padding ? DrawerPadding : []), transform.value]);
    const contentStyles = computed(() => [...DrawerContent]);
    // State
    const {
      state,
      open,
      close,
      toggle
    } = te(toRef(props, 'isOpen'), context.emit);
    // eslint-disable-next-line vue/return-in-computed-property
    const transform = computed(() => {
      switch (props.placement) {
        case DrawerPlacement.Left:
          return state.value === 'closed' ? '-translate-x-[calc(100%+80px)]' : 'translate-x-0';
        case DrawerPlacement.Right:
          return state.value === 'closed' ? 'translate-x-[calc(100%+80px)]' : 'translate-x-0';
      }
    });
    // Effects
    onClickOutside(root, event => {
      const path = event.composedPath();
      const ignoreClasses = ['or-popover-v3', 'or-bottom-sheet-v3', 'or-modal-v3', 'or-confirm-v3'];
      if (!path.some(({
        classList
      }) => ignoreClasses.some(ignoreClass => classList === null || classList === void 0 ? void 0 : classList.contains(ignoreClass)))) {
        close();
      }
    });
    useSwipe(root, {
      onSwipeEnd: (event, direction) => {
        switch (props.placement) {
          case DrawerPlacement.Left:
            if (direction === SwipeDirection.LEFT) close();
            break;
          case DrawerPlacement.Right:
            if (direction === SwipeDirection.RIGHT) close();
            break;
        }
      }
    });
    return {
      root,
      rootStyles,
      contentStyles,
      state,
      open,
      close,
      toggle
    };
  }
});

function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrOverlay = resolveComponent("OrOverlay");
  return _ctx.state === 'open' ? (openBlock(), createBlock(_component_OrOverlay, {
    key: 0,
    fullscreen: true
  }, {
    default: withCtx(() => [createElementVNode("div", mergeProps(_ctx.$attrs, {
      ref: 'root',
      class: _ctx.rootStyles
    }), [createElementVNode("div", {
      class: normalizeClass(_ctx.contentStyles)
    }, [renderSlot(_ctx.$slots, "default")], 2 /* CLASS */)], 16 /* FULL_PROPS */)]),
    _: 3 /* FORWARDED */
  })) : createCommentVNode("v-if", true);
}

script.render = render;
script.__file = "src/components/or-drawer-v3/OrDrawer.vue";

export { DrawerPlacement, script as OrDrawerV3 };
